import { useMemo } from "react";
import { TIME_SLOTS } from "../types";

interface DateTimeStepProps {
  selectedDate: string;
  selectedTime: string;
  onDateChange: (date: string) => void;
  onTimeChange: (time: string) => void;
}

const WEEKDAYS = [
  "Chủ nhật",
  "Thứ 2",
  "Thứ 3",
  "Thứ 4",
  "Thứ 5",
  "Thứ 6",
  "Thứ 7",
];

function formatDateKey(d: Date): string {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

export default function DateTimeStep({
  selectedDate,
  selectedTime,
  onDateChange,
  onTimeChange,
}: DateTimeStepProps) {
  const days = useMemo(() => {
    const result: { key: string; dayOfMonth: number; weekday: string }[] = [];
    const today = new Date();
    for (let i = 0; i < 14; i++) {
      const d = new Date(today);
      d.setDate(today.getDate() + i);
      result.push({
        key: formatDateKey(d),
        dayOfMonth: d.getDate(),
        weekday: WEEKDAYS[d.getDay()],
      });
    }
    return result;
  }, []);

  return (
    <div className="space-y-6">
      {/* Date selection */}
      <div>
        <h3 className="font-display text-lg font-semibold text-foreground-950 mb-3">
          Chọn ngày
        </h3>
        <div className="grid grid-cols-4 sm:grid-cols-7 gap-2">
          {days.map((day) => {
            const isSelected = selectedDate === day.key;
            return (
              <button
                key={day.key}
                type="button"
                onClick={() => onDateChange(day.key)}
                className={`flex flex-col items-center gap-1 py-3 rounded-lg border-2 transition-all cursor-pointer ${
                  isSelected
                    ? "border-primary-500 bg-primary-50"
                    : "border-background-200/70 bg-background-50 hover:border-primary-300"
                }`}
              >
                <span className="text-[11px] font-label text-foreground-500">
                  {day.weekday}
                </span>
                <span
                  className={`text-base font-semibold font-label ${
                    isSelected ? "text-primary-700" : "text-foreground-900"
                  }`}
                >
                  {day.dayOfMonth}
                </span>
              </button>
            );
          })}
        </div>
      </div>

      {/* Time selection */}
      <div>
        <h3 className="font-display text-lg font-semibold text-foreground-950 mb-3">
          Chọn giờ
        </h3>
        <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-6 gap-2">
          {TIME_SLOTS.map((slot) => {
            const isSelected = selectedTime === slot;
            return (
              <button
                key={slot}
                type="button"
                onClick={() => onTimeChange(slot)}
                className={`py-2.5 rounded-md border-2 text-sm font-label font-medium transition-all cursor-pointer ${
                  isSelected
                    ? "border-primary-500 bg-primary-500 text-background-50"
                    : "border-background-200/70 bg-background-50 text-foreground-700 hover:border-primary-300"
                }`}
              >
                {slot}
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}